import React from 'react';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import {Getstarted} from '../../../components/essentials/get-started/getstarted.component';

import phoneImg from '../../../assest/wallet/Intro (1).jpg';
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import photoOnPhone from '../../../assest/wallet/Features.png'
import benefits from '../../../assest/wallet/Benefits (1).jpg'
import './wallet.scss';
//import { OverlapBoxTechno } from '../../technopage/techno.component';
import {  OverlapBoxFeature } from '../features-page/features-page.component';

import tobacco from '../../../assest/wallet/icons (1)/FS.png';
import gamble from '../../../assest/wallet/icons (1)/Edu.png';
import alcohol from '../../../assest/wallet/icons (1)/PS.png';
import cbd from '../../../assest/wallet/icons (1)/Health.png';
import content from '../../../assest/wallet/icons (1)/Smart.png';
import pharma from '../../../assest/wallet/icons (1)/Retail.png';
import diy from '../../../assest/wallet/icons (1)/Travel.png';

import global from '../../../assest/wallet/Integration Square.jpg'
import { useHistory } from "react-router";
import { Link } from 'react-router-dom';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';
//import {  MediumCard } from '../platformpage/platform.component';
//import { OverlapBox } from '../../../components/essentials/overlap-box/overlap-box.component';
import { useTranslation } from 'react-i18next';

export const Wallet = () => {
  const { t } = useTranslation('id-wallet');

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('walletTitle')} uris={t('walletUri')} />

      <OverlapBoxTechno img={phoneImg} title={t('introTitle')}>
        <TrackedSection sectionName="WalletPage IntroSection">
          <p>{t('introP1')}</p>
          <p>{t('introP2')}</p>
          <p>{t('introP3')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <OverlapBoxFeature title={t('keyFeatures')}>
        <TrackedSection sectionName="WalletPage Features">
          <MoreBox />
        </TrackedSection>
      </OverlapBoxFeature>

      <OverlapBoxIndustry title={t('industryUseCases')}>
        <TrackedSection sectionName="WalletPage UseCases">
          <div className='cards-div-industries'>
            {[
              ['Financial Services – Customer Wallet', ''],
              ['Education – Student Wallet', ''],
              ['Public Services – Citizen Wallet', ''],
              ['Healthcare – Patient Wallet', ''],
              ['Smart Cities – Resident Wallet', ''],
              ['Retail/E-Commerce – Shopper Wallet', ''],
              ['Travel & Hospitality – Traveler Wallet', '']
            ].map(([title, _], i) => (
              <LargeCard
                key={i}
                img={[tobacco, gamble, alcohol, cbd, content, pharma, diy][i]}
                title={title}
                desc={t(`more${i + 1}Content`)}
              />
            ))}
          </div>
        </TrackedSection>
      </OverlapBoxIndustry>

      <OverlapBoxFeature title={t('solutionBenefits')}>
        <TrackedSection sectionName="WalletPage SolutionBenefits">
          <EarthidBox t={t} />
        </TrackedSection>
      </OverlapBoxFeature>

      <SectionRight2
        title={t('integrationTitle')}
        desc={t('integrationContent')}
        title1={t('integration1Title')}
        content1={t('integration1Content')}
        title2={t('integration2Title')}
        content2={t('integration2Content')}
        title3={t('integration3Title')}
        content3={t('integration3Content')}
        title4={t('integration4Title')}
        content4={t('integration4Content')}
        imgPath={global}
      />

      <Getstarted />
      <Footer />
    </div>
  );
};

  
  

const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-distributee'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
        Solutions / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

// const KDTCard = ({ icon, desc, title }) => {
//   return (
//     <div className='kys-card'>
//       <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
//       <div >
//         <p className='kys-card-title'>{title}</p>
//         <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
//       </div>
//     </div>
//   );
// };

const MoreBox = props => {
  const { t } = useTranslation('id-wallet');
    return (
      <div className='kidv-div'>
      <div className='kys-platform-img-top'>
        <img src={photoOnPhone} className='kys-platform-image' alt='EarthID Image' />
      </div>
      <div className='kys-div'>
        <div className='kys-platform-content'>
          <KYSCard icon={kysBulletPoint} title={t('secureCredentialTitle')} desc={t('secureCredentialDesc')} />
          <KYSCard icon={kysBulletPoint} title={t('reuseVerifiedTitle')} desc={t('reuseVerifiedDesc')} />
          <KYSCard icon={kysBulletPoint} title={t('selectiveDisclosureTitle')} desc={t('selectiveDisclosureDesc')} />
        </div>
        <div className='kys-platform-content'>
          <KYSCard icon={kysBulletPoint} title={t('unifiedCommTitle')} desc={t('unifiedCommDesc')} />
          <KYSCard icon={kysBulletPoint} title={t('passwordlessAuthTitle')} desc={t('passwordlessAuthDesc')} />
          <KYSCard icon={kysBulletPoint} title={t('complianceTitle')} desc={t('complianceDesc')} />
        </div>
      </div>
    </div>
  
    );
  };

  const OverlapBoxIndustry = props => {
    return (
      <div className='overlap-boxx'>
        <p className='box-title'>{props.title}</p>
        {props.children}
      </div>
    );
  };

  const LargeCard = ({ img, desc, title }) => {
    return (
      <div className='largeind-card'>
        <img src={img} className='large-card-img' alt='largeCardImg' />
        <p className='large-card-title'>{title}</p>
        <p className='large-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    );
  };

  const EarthidBox = () => {
    const { t } = useTranslation('id-wallet');
  
    return (
      <div className='kidv-div'>
        <div className='kys-platform-img-top'>
          <img src={benefits} className='kys-platform-image' alt='EarthID Image' />
        </div>
        <div className='kys-div'>
          <div className='kys-platform-content'>
            <KYSCard icon={kysBulletPoint} title={t('seamlessIntegrationTitle')} desc={t('seamlessIntegrationDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('operationalEfficiencyTitle')} desc={t('operationalEfficiencyDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('fraudPreventionTitle')} desc={t('fraudPreventionDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('regulatoryConfidenceTitle')} desc={t('regulatoryConfidenceDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('globalCoverageTitle')} desc={t('globalCoverageDesc')} />
          </div>
          <div className='kys-platform-content'>
            <KYSCard icon={kysBulletPoint} title={t('customerTrustTitle')} desc={t('customerTrustDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('scalabilityTitle')} desc={t('scalabilityDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('costSavingsTitle')} desc={t('costSavingsDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('competitiveEdgeTitle')} desc={t('competitiveEdgeDesc')} />
            <KYSCard icon={kysBulletPoint} title={t('interoperabilityTitle')} desc={t('interoperabilityDesc')} />
          </div>
        </div>
      </div>
    );
  };


  const SectionRight2 = props => {
    return (
      <div className='feature-box-rights'>
        <p className='title-feature'>{props.title}</p>
        <p className='desc1-feature'>{props.desc}</p>
        <div className="kys-div">
          <div className='kys-platform-content'>
  
              {/* Conditionally render KDTCard if both title1 and content1 exist */}
              {props.title1 && props.content1 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title1}
                  desc={props.content1}
                />
              )}
  
              {/* Conditionally render KYSCard if both title2 and content2 exist */}
              {props.title2 && props.content2 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title2}
                  desc={props.content2}
                />
              )}
  
              {/* Conditionally render KYSCard if both title3 and content3 exist */}
              {props.title3 && props.content3 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title3}
                  desc={props.content3}
                />
              )}
  
              {/* Conditionally render KYSCard if both title4 and content4 exist */}
              {props.title4 && props.content4 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title4}
                  desc={props.content4}
                />
              )}
  
              {/* Conditionally render KYSCard if both title5 and content5 exist */}
              {props.title5 && props.content5 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title5}
                  desc={props.content5}
                />
              )}
  
              {/* Conditionally render KYSCard if both title6 and content6 exist */}
              {props.title6 && props.content6 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title6}
                  desc={props.content6}
                />
              )}
  
              {/* Conditionally render KYSCard if both title7 and content7 exist */}
              {props.title7 && props.content7 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title7}
                  desc={props.content7}
                />
              )}
  
              {/* Conditionally render KYSCard if both title8 and content8 exist */}
              {props.title8 && props.content8 && (
                <KYSCard
                  icon={kysBulletPoint}
                  title={props.title8}
                  desc={props.content8}
                />
              )}
  
            </div>
            <div className={`kys-platform-imgdt`}>
            <img src={props.imgPath} className='kys-platform-imageedt' alt="feature-img" />
          </div>
         
  
         
        </div>
      </div>
    );
  };
  



 const KYSCard = ({ icon, desc, title }) => {
    return (
      <div className='kys-card'>
        <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
        <div className="key-text-col">
          <p className='kys-card-title'>{title}</p>
          <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
        </div>
      </div>
    );
  };

 const OverlapBoxTechno = ({ img, title, children }) => {

  const history = useHistory();

  const handleRequestDemo = e => {
      history.push("/apps");
      window.scrollTo(0, 0);
    };

    return (
      <div className='overlap-box-technoo'>
        <img src={img} alt='phone-img' className='techno-imgDT' />
        <div className='techno-content'>
          <p className='techno-title'>{title}</p>
          <div className='rest-para'>{children}</div>
          <button className='footer-btn_1' onClick={handleRequestDemo}>
          <Link className='links'>
            <p className='btn-title'>Download EarthID Wallet</p>
          </Link>
        </button>
        </div>
      </div>
    );
  };


